import { colors } from './colors';

export const slider = {
  rail: {
    height: '3px',
    background: colors.greys.alto,
  },
  track: {
    background: colors.brand.primary,
    height: '3px',
  },
  handle: {
    border: `2px solid ${colors.brand.primary}`,
    background: colors.brand.primary,
    width: '24px',
    height: '24px',
    top: '-1px',
  },
};
